import React from 'react';
import Relay from 'react-relay';
import DatePicker from 'react-bootstrap-date-picker';
import Select from 'react-select';
import EditSportunity from './EditSportunity';
import SportunitiesList from './SportunitiesList';

import Button from '../../components/Button';

import { isValidEmailAddress } from '../../components/UserPanel'

const getOptionsFromSports = (sports) => sports && sports.edges.map((edge) => ({
  value: edge.node.id, label: edge.node.name.EN,
}))

export const getOptionsFromUsers = (users) => users && users.edges.length && users.edges.map((edge) => ({
  value: edge.node.pseudo, label: edge.node.pseudo, user: edge.node,
}))

const sportunitiesKindOptions = [{
  value: 'PUBLIC',
  label: 'Public',
}, {
  value: 'PRIVATE',
  label: 'Private',
}]

class SportunitiesPage extends React.Component {

  state = {
    currentFilter: '',
    dateFrom: '',
    dateTo: '',
    searchBySport: {},
    searchByOrganizeId: null,
    searchByPublicKind: null,
    selectLevels: null,
  }

  handleDateChange(value, formattedValue) {

    let {that, id} = this;
    let dateFrom, dateTo;

    if (id == "datePickerFrom") {
      if (value == null) value = "2017/01/01 01:00:01";
      that.setState({
        dateFrom: new Date(value).toISOString()
      });
      dateFrom = new Date(value).toISOString();
      dateTo = that.state.dateTo;
    }
    else if (id == "datePickerTo") {
      if (value == null) value = new Date();
      that.setState({
        dateTo: new Date(value).toISOString()
      });
      dateFrom = that.state.dateFrom;
      dateTo = new Date(value).toISOString();
    }

    let path = '/sportunities/list/custom';
    that.props.router.push({
      pathname : path,
      state: {
        dateFrom: dateFrom,
        dateTo: dateTo
      }
    });
  }

  _onButtonClick() {
    let {that, text} = this.props;

    if (text == "Return") {
      let dateFrom = that.state.dateFrom;
      let dateTo = that.state.dateTo;

      let path = '/sportunities/list/custom';
      that.props.router.push({
        pathname : path,
        state: {
          dateFrom: dateFrom,
          dateTo: dateTo
        }
      });
    }
    else {
      that.setState({
        currentFilter: text
      });

      let dateFrom = new Date("2017/01/01 01:00:01");
      let dateTo = new Date();

      if (text == "Today") {
        dateFrom = new Date();
        dateFrom.setHours(1,0,0,0);
      }
      else if (text == "Yesterday") {
        dateFrom = new Date();
        dateFrom.setDate(dateFrom.getDate() - 1);
        dateFrom.setHours(1,0,0,0);
        dateTo.setHours(0,0,0,0);
      }
      else if (text == 'All') {
        dateTo = new Date('2099/12/31')
      }

      dateFrom = dateFrom.toISOString();
      dateTo = dateTo.toISOString();

      that.setState({
        dateFrom: dateFrom,
        dateTo: dateTo
      })

      let path = '/sportunities/list/'+text.toLowerCase();
      that.props.router.push({
        pathname : path,
        state: {
          dateFrom: dateFrom,
          dateTo: dateTo
        }
      });
    }
  }

  _renderFilterButton(filterName, index) {
    let color = 'btn-default';

    if (filterName == this.state.currentFilter) {
      color = 'btn-danger';
    }

    return <Button
              text={filterName}
              key={index}
              that={this}
              color={color}
              onClick={this._onButtonClick}
            />
  }

  _renderChildren = () =>
    React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        ...this.props,
        searchBySport: this.state.searchBySport,
        searchByOrganizeId: this.state.searchByOrganizeId,
        searchByPublicKind: this.state.searchByPublicKind,
        dateFrom: this.state.dateFrom,
        dateTo: this.state.dateTo,
      })
    )

  _updateSearch = () => {
    const newCurrentFilter = this.state.currentFilter || 'All'
    const newState = {
      currentFilter: newCurrentFilter,
    }

    if (this.state.currentFilter !== newCurrentFilter) {
      const pathname = '/sportunities/list/custom';
      this.props.router.push({
        pathname,
        state :{
          ...newState,
          filter : 'All',
        }
      });
    }

    this.setState(newState);
  }

  _getLevelSelectFrom = (sportId) => this.props.viewer &&
    this.props.viewer.sports.edges.find(({ node: { id } }) => id === sportId)
      .node.levels.map(({ id, EN: { name }}) => ({ value: id, label: name }))

  _handleSportSelectChange = (option) => {
    this.setState({
      searchBySport: {
        id: (option || {}).value,
        level: null,
      },
      selectLevels: option && this._getLevelSelectFrom((option || {}).value)
    }, () => this._updateSearch())
  }

  _handleSportLevelSelectChange = (option) =>
    this.setState({
      searchBySport: {
        id: this.state.searchBySport.id,
        level: (option || {}).value
      },
    })

  _handlePublicKindSelectChange = (option) =>
    this.setState({
      searchByPublicKind: (option || {}).value,
    }, this._updateSearch)

  _handleUserSearchInput = (inputContent) => {
    clearTimeout(this._handleUserSearchInput.timeout)
    const fireIt = () => this._handleAutocompleteUserQueryChange(inputContent)
    this._handleUserSearchInput.timeout = setTimeout(fireIt, 400)
  }

  _handleAutocompleteUserQueryChange = (query) => {
    const isEmail = isValidEmailAddress(query)
    this.props.relay.setVariables({
      pseudo_autocomplete: !isEmail? query : null,
      email_autocomplete: isEmail? query : null,
      autocompletion_required: true,
    })
  }

  _handleUserSearchSelection = (option) => this.setState({
    autocompleteEmail: '',
    autocompletePseudo: option && option.label,
    autocompleteUserSelected: option && option.user,
    autocompleteUsersQuery: option && option.label,
    searchByOrganizeId: ((option || {}).user || {}).id,
  }, () => {
    this.props.relay.setVariables({
      pseudo_autocomplete: (option || {}).label,
      email_autocomplete: null,
      autocompletion_required: true,
    })
    this._updateSearch()
  })

  renderOption = (option) => (
		<div style={{ display: 'flex', flexDirection: 'row'}}>
      <img src={option.user.avatar} style={{ height: 20, width: 'auto', padding: 4, verticalAlign: 'middle' }} />
      {option.label}
    </div>
  )

  getOptionFromSelectedUser = () =>
    this.state.autocompleteUserSelected
      ? [{
        value: this.state.autocompleteUserSelected.id,
        label: this.state.autocompleteUserSelected.pseudo,
        user: this.state.autocompleteUserSelected,
      }]
      : []


  render() {
    let filters = ["All", "Today","Yesterday"];
    return (
      <div>
        <div style={{marginTop:20, marginBottom: 20, display: 'flex',flexDirection:'row'}}>
            {filters.map((filterName,index) => this._renderFilterButton(filterName,index))}
            <div style={{width:300, display: 'flex', marginLeft:25}}>
              <DatePicker id="datePickerFrom" value={this.state.dateFrom} that={this} placeholder="From" onChange={this.handleDateChange}/>
            </div>
            <div style={{width:300, display: 'flex', marginLeft:25}}>
              <DatePicker id="datePickerTo" value={this.state.dateTo} that={this} placeholder="To" onChange={this.handleDateChange}/>
            </div>
            <div>
              <Button
              text="Return"
              that={this}
              onClick={this._onButtonClick}
            />
            </div>
          </div>
          <div style={{marginTop:20, marginBottom: 20, display: 'flex',flexDirection:'row'}}>
            <div style={styles.sportSelectContainer}>
              <Select
                placeholder='Search by Sport'
                options={getOptionsFromSports(this.props.viewer.sports)}
                value={this.state.searchBySport.id}
                onChange={this._handleSportSelectChange}
                onOpen={() => this.props.relay.setVariables({querySports: true})}
                isLoading={this.props.relay.pendingVariables}
                loadingPlaceholder={"Loading"}
              />
            </div>
            {this.state.selectLevels && this.state.selectLevels.length && (
              <div style={styles.sportSelectContainer}>
                <Select
                  placeholder='By Sport Level'
                  options={this.state.selectLevels}
                  value={this.state.searchBySport.level}
                  onChange={this._handleSportLevelSelectChange}
                />
              </div>
            )}
            <div style={styles.sportSelectContainer}>
              <Select
                options={[
                  ...this.getOptionFromSelectedUser(),
                  ...(getOptionsFromUsers(this.props.viewer.autocompleteUsers) || [])
                ]}
                value={(this.state.autocompleteUserSelected || {}).id || this.state.autocompleteUsersQuery}
                placeholder='By Organizer'
                onChange={this._handleUserSearchSelection}
                onInputChange={this._handleUserSearchInput}
                optionRenderer={this.renderOption}
              />
            </div>
            <div style={styles.sportSelectContainer}>
              <Select
                options={sportunitiesKindOptions}
                value={this.state.searchByPublicKind}
                placeholder='By Kind'
                onChange={this._handlePublicKindSelectChange}
              />
            </div>
        </div>
        {this._renderChildren()}
      </div>
    );
  }
}

const styles = {
  input: {
    borderRadius: 20,
    padding: 5,
    minWidth: 250,
  },
  sportSelectContainer: {
    display: 'inline-block',
    marginLeft: 15,
    minWidth: 200,
    height: 26,
  },
}


export default Relay.createContainer(SportunitiesPage, {
  initialVariables: {
    pseudo_autocomplete: null,
    email_autocomplete: null,
    autocompletion_required: false,
    querySports: false
  },
  fragments: {
    viewer: (variables) => Relay.QL`
      fragment on Viewer {
        id

        sports(first: 1000) @include(if: $querySports) {
          edges {
            node {
              id
              name {
                EN
              }
              levels {
                id
                EN {
                  name
                }
              }
            }
          }
        }

        autocompleteUsers: users (pseudo: $pseudo_autocomplete, email: $email_autocomplete, last: 5) @include(if: $autocompletion_required) {
          edges {
            node {
              id
              pseudo
              avatar
            }
          }
        }

        ${EditSportunity.getFragment('viewer')}
        ${SportunitiesList.getFragment('viewer', variables)}
      }
    `,
  }
})



// WEBPACK FOOTER //
// ./src/pages/Sportunity/SportunitiesPage.js